import { Platform, setConfigStateById } from '../ConfigContext';

export const setPlatform = (setState: setConfigStateById) => (value: Platform) => {
  setState('SET_PLATFORM', (s) => ({
    ...s,
    platform: value,
  }));
};
